const paymentsGoBack = document.querySelector(".result__go-back");
const backLink = localStorage.getItem("payments-link");

if (paymentsGoBack) {
    paymentsGoBack.href = backLink || "/#options";
    
    paymentsGoBack.addEventListener("click", () => {
        localStorage.removeItem("payments-link");
    });
}

